import { Component, inject } from '@angular/core';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import {map, shareReplay} from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {SideMenuComponent} from "../../common/side-menu/side-menu.component";
import {MatListItem, MatNavList} from "@angular/material/list";
import {MatSidenav, MatSidenavContainer, MatSidenavContent} from "@angular/material/sidenav";
import {MatToolbar} from "@angular/material/toolbar";
import {Observable} from "rxjs";
import {RouterOutlet} from "@angular/router";
import {TopBarComponent} from "../../common/top-bar/top-bar.component";
import {HeadingComponent} from "../../common/heading/heading.component";
import {LoadingService} from "../../domain/services/loading/loading.service";
import {ImpersonationService} from "../../domain/services/impersonation/impersonation.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
  standalone: true,
  imports: [
    AsyncPipe,
    MatGridListModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatProgressBarModule,
    SideMenuComponent,
    MatListItem,
    MatNavList,
    MatSidenav,
    MatSidenavContainer,
    MatSidenavContent,
    MatToolbar,
    RouterOutlet,
    TopBarComponent,
    HeadingComponent
  ]
})
export class HomeComponent {
  private breakpointObserver = inject(BreakpointObserver);
  loadingService = inject(LoadingService);
  impersonation = inject(ImpersonationService);

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
}
